// extracted by mini-css-extract-plugin
export var modalFooter = "_qj-0";